import { Box, useMediaQuery } from "@mui/material";
import { EmployeeServicePath, MOBILE_BREAKPOINT, STAFF_REQUEST, StaffRequestTypes } from "utils/constants";
import { Button, Datagrid, DateField, FunctionField, ReferenceField, SelectField, SimpleList } from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { EmptyList } from "server/components";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

import { StaffRequestStatus, StaffRequestType } from "utils/choices";
import { useNavigate } from "react-router";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { accountRequests } from "api/accountApi";
import RequestActionBox from "../DetailsStaffRequest/RequestActionBox";
import BulkRequestActions from "./BulkRequestActions";

const RowActions = ({ record, navigate, iconOnly = false, showApproveButton = true }) => {
  const requestId = record?.staffRequestId ?? record?.id;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 1, flexWrap: "wrap" }}>
      {/* No details endpoint for a cancellation request yet. */}
      {record?.type !== StaffRequestTypes.CancelAbsence && (
        <Button
          label={iconOnly ? "" : "Детайли"}
          onClick={() =>
            navigate(`/${EmployeeServicePath}details/${STAFF_REQUEST}/${requestId}`, {
              state: { type: record?.type },
            })
          }
        >
          <VisibilityIcon />
        </Button>
      )}
      <RequestActionBox
        requestId={requestId}
        type={record?.type}
        status={record?.status}
        redirectBack={false}
        showApproveButton={showApproveButton}
      />
    </Box>
  );
};

const StaffRequestsTableBody = ({ showApproveButton = true }) => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const navigate = useNavigate();

  return isMobile ? (
    <SimpleList
      empty={<EmptyList />}
      linkType={false}
      sx={settings.style.mobileList}
      secondaryText={record => (
        <div>
          <MobileListRow
            fields={[
              {
                label: "Тип",
                value: (
                  <SelectField
                    source="type"
                    label="Тип"
                    choices={StaffRequestType}
                  />
                ),
              },
            ]}
          />
          <MobileListRow
            fields={[
              {
                label: "Създаден от",
                value: (
                  <ReferenceField
                    source="createdByUserId"
                    label="Създаден от"
                    reference={accountRequests.getUsersSelect()}
                  >
                    <FunctionField
                      label="Създаден от"
                      render={rec =>
                        rec.secondName
                          ? `${rec.firstName}  ${rec.secondName} ${rec.lastName}`
                          : `${rec.firstName} ${rec.lastName}`
                      }
                    />
                  </ReferenceField>
                ),
              },
            ]}
          />
          <MobileListRow
            fields={[
              {
                label: "Създаден",
                value: (
                  <DateField
                    source="createdOn"
                    label="Създаден"
                    locales="bg-BG"
                    showTime
                  />
                ),
              },
            ]}
          />
          <MobileListRow
            fields={[
              {
                label: "Статус",
                value: (
                  <SelectField
                    source="status"
                    label="Статус"
                    choices={StaffRequestStatus}
                  />
                ),
              },
            ]}
          />
        </div>
      )}
      tertiaryText={record => (
        <SecuredComponent permission={permissions.canPreviewStaffRequests}>
          <RowActions
            record={record}
            navigate={navigate}
            iconOnly
            showApproveButton={showApproveButton}
          />
        </SecuredComponent>
      )}
    />
  ) : (
    <>
      <Datagrid
        rowClick={false}
        bulkActionButtons={showApproveButton ? <></> : false}
      >
      <SelectField
        source="type"
        label="Тип"
        choices={StaffRequestType}
      />
      <ReferenceField
        source="createdByUserId"
        label="Създаден от"
        reference={accountRequests.getUsersSelect()}
      >
        <FunctionField
          label="Създаден от"
          render={rec =>
            rec.secondName
              ? `${rec.firstName}  ${rec.secondName} ${rec.lastName}`
              : `${rec.firstName} ${rec.lastName}`
          }
        />
      </ReferenceField>
      <DateField
        source="createdOn"
        label="Създаден"
        locales="bg-BG"
        showTime
      />
      <SelectField
        source="status"
        label="Статус"
        choices={StaffRequestStatus}
      />
      <SecuredComponent
        label="Действия"
        permission={permissions.canPreviewStaffRequests}
      >
        <FunctionField
          label="Действия"
          render={rec => (
            <RowActions
              record={rec}
              navigate={navigate}
              showApproveButton={showApproveButton}
            />
          )}
        />
      </SecuredComponent>
      </Datagrid>
      {showApproveButton && <BulkRequestActions />}
    </>
  );
};

export default StaffRequestsTableBody;
